import type { CartGetData, MakeCartAPIArgs } from 'src/types';
import { baseFetch } from 'src/utils';

type Args = {
  cart: CartGetData | undefined;
};

export const duplicateCartAPI = async ({ cart }: Args): Promise<string> => {
  if (!cart) {
    throw new Error();
  }

  // TODO - We might need to modify the item url's to remove the forwarder info
  const items = cart.items.map((item) => ({
    ...item,
    img: item.image || null,
    name: item.title || null,
  }));

  const body: MakeCartAPIArgs = {
    cartid: null, // should always be null here since we are duplicating a cart
    cart: items,
    vendor: cart.vendor,
    title: cart.title || null,
    note: cart.note || null,
    dest: cart.dest || null,
    password: null, // should always be null
    ap: cart.ap || null,
    ccy: cart.ccy || null,
  };

  const res = await baseFetch(`/api/make/saveWithMetadata`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    throw new Error();
  }

  const data = await res.json();

  // API returns cartid, not cartId
  return data.cartid;
};
